<template>
  <div class="ts-metric">
    <p class="value"><slot></slot></p>
    <p v-if="title" class="title">{{ title }}</p>
  </div>
</template>

<style lang="scss" scoped>
.ts-metric {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 12px;

  display: inline-block;
  padding: 8px;

  .value {
    font-family: Roboto;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #242424;

    margin: 0;
  }

  .title {
    font-family: Roboto;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    color: #6d7587;

    margin: 0;
  }
}
</style>

<script>
export default {
  name: 'TsMetric',
  props: {
    title: {
      type: String,
      default: null
    }
  }
};
</script>
